import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import translationKeys from '@translationKeys'

import BlankStateImage from '@assets/images/blank_state_placeholder.jpg'
import { Typography } from '@mui/material'

import { EmptyProfilesInner, EmptyProfilesWrapper, EmptyShortlistButton, EmptyShortlistPicture } from './index.styles'

export const EmptyState = ({ isEcommerce }: { isEcommerce: boolean }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <EmptyProfilesWrapper>
      <EmptyProfilesInner>
        <Typography variant="h2">
          {isEcommerce ? t(translationKeys.EMPTY_ECOMMERCE_CUSTOM_LISTS_TITLE) : t(translationKeys.EMPTY_CUSTOM_LISTS_TITLE)}
        </Typography>
        <EmptyShortlistPicture src={BlankStateImage} alt="blank state image" />
        <EmptyShortlistButton onClick={() => navigate('/plus/search')} id="shortlist-start_list">
          {t(translationKeys.EMPTY_CUSTOM_LISTS_BTN)}
        </EmptyShortlistButton>
      </EmptyProfilesInner>
    </EmptyProfilesWrapper>
  )
}
